import { render, staticRenderFns } from "./HspDefaultLayout.vue?vue&type=template&id=54895b37"
import script from "./HspDefaultLayout.vue?vue&type=script&lang=js"
export * from "./HspDefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./HspDefaultLayout.vue?vue&type=style&index=0&id=54895b37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports